function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width,
    height: props.height,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: props.viewBox
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M118.617 36.603 103.5 51.78 88.323 66.897 73.206 82.074l8.868 8.808L97.19 75.765l6.309 6.309L82.014 103.5 60.588 82.074 90.882 51.78l-8.868-8.868-34.698 34.757v8.809l30.294 30.294h8.808l30.294-30.294v-8.809l-10.713-10.772 6.309-6.309 21.486 21.486-51.78 51.779-51.72-51.78 51.72-51.779 15.177 15.177 8.808-8.868-19.521-19.581H77.61L17.022 77.669v8.809l60.588 60.588h8.808l60.588-60.588v-8.809l-25.83-25.89 6.309-6.308 36.603 36.603-82.074 82.073L0 82.074 82.074 0l36.543 36.603Z",
    fill: props.color,
    stroke: props.color
  }));
};
export default SvgLogo;